<div class="new-leads-created">
    <div class="new-leads-created__header">
        <h3 class="new-leads-created__title">
            {{ AppConstants.NEW_LEADS_CREATED_TITLE }}{{ getTitleSuffix() }}
        </h3>
        <button
            class="new-leads-created__info-icon"
            [eiTooltip]="getTooltipText()"
            eiTooltipPosition="top"
            aria-label="Info"
            type="button"
        >
            <img [src]="infoIcon" alt="" class="new-leads-created__info-img" />
        </button>
    </div>

    @if (isLoading) {
        <div class="new-leads-created__loading">
            <div class="new-leads-created__spinner"></div>
        </div>
    } @else if (error) {
        <div class="new-leads-created__error">
            <p class="new-leads-created__error-text">{{ error }}</p>
        </div>
    } @else if (hasNoRecords) {
        <div class="new-leads-created__empty">
            <p class="new-leads-created__empty-text">
                No records are available for selected filters.
            </p>
        </div>
    } @else if (chartOptions) {
        <div class="new-leads-created__chart">
            <apx-chart
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [yaxis]="chartOptions.yaxis"
                [dataLabels]="chartOptions.dataLabels"
                [legend]="chartOptions.legend"
                [fill]="chartOptions.fill"
                [colors]="chartOptions.colors"
                [tooltip]="chartOptions.tooltip"
            ></apx-chart>
        </div>
    }
</div>
